import _ from 'lodash';
const initialState ={
  userspayload:[],
  showModalLogin:false,
  large:true
}
export default (state = initialState, action) => {
  let new_userspayload = _.cloneDeep(state.userspayload)
  let filterresult = _.cloneDeep(action.result)
  _.remove(filterresult, {employeeId: "SysAdmin"})
  switch (action.type) {   
   case "USER_ACTION":
    return Object.assign({}, state, {
      userspayload: filterresult,
      isPending: action.isPending
    })
    case "USER_ACTION_PENDING":
    return Object.assign({}, state, {
      isPending: action.isPending
    })
    case "USER_ACTION_ADD":
        new_userspayload.push(action.newData)
      return Object.assign({}, state, {
        userspayload: new_userspayload,
        isPending: action.isPending
      })
    case "USER_ACTION_EDIT":
      var id = action.newData.employeeId
      var index = new_userspayload.findIndex(item => item.employeeId === id) 
      new_userspayload.splice(index, 1, action.newData)
      return Object.assign({}, state, {
        userspayload: new_userspayload,
        isPending: action.isPending
      })
      case "USER_STATUS":
        var iid = action.StatusWise.id
        var index1 = new_userspayload.findIndex(item => item.id === iid) 
        new_userspayload[index1].status = action.StatusWise.status
        return Object.assign({}, state, {
        userspayload: new_userspayload,
        isPending: action.isPending
      })
    case "USER_ACTION_EDIT_ERROR":
      return Object.assign({}, state, {
        errmessage: action.errmessage,
        showerror: action.showerror,
        isPending: action.isPending
    })   
    case "USER_ACTION_MODAL_CLOSE": 
      return Object.assign({}, state, {
       showerror: action.showerror
    }) 
    case "USER_ACTION_CATEGORY":
      return Object.assign({}, state, {
        category: action.category
      })
    case "USER_ACTION_SUPERVISOR":
     
      return Object.assign({}, state, {
        supervisor:  _.orderBy(action.supervisor, ['supervisorUsersName'] , ['asc'])
      })
    case "USER_ACTION_ROLES":
      return Object.assign({}, state, {
        roles: action.roles
      })
    case "DASHBOARD_LENGTH":
        return Object.assign({}, state, {
          large: action.size
        })
    case "USER_ACTION_MAPPED_INVENTORY":
      return Object.assign({}, state, {
        inventoryMapped: action.inventoryMapped
      })
      case "SHOW_LOGIN_MODAL":
        return Object.assign({}, state, {
          showModalLogin: action.showModalLogin
        })
        case "SHOW_LOGIN_MODAL_FALSE":
          return Object.assign({}, state, {
            showModalLogin: action.showModalLogin
          })
   default:
    return state
  }
 }